export default __webpack_public_path__ + "static/media/938.26811ec7.png";